import { useNavigate, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import useAuthStore from 'context/AuthStore/useAuthStore'
import { LAST_VISIT, PREV_PAGE, SessionStorageService } from 'lib/utils'
import { HOME_PATH, SIGN_IN_PATH } from 'routes/constants.routes'

const useRoutes = () => {
  const { authStoreFunc } = useAuthStore()
  const navigate = useNavigate()
  const location = useLocation()

  const lastVisit = sessionStorage.getItem(LAST_VISIT)
  const prevPage = sessionStorage.getItem(PREV_PAGE)

  const setLastVisit = path => {
    SessionStorageService.setLastVisit(path)
  }
  setLastVisit.propTypes = {
    path: PropTypes.string.isRequired
  }

  const setPrevPage = path => {
    SessionStorageService.setPrevPage(path)
  }
  setPrevPage.propTypes = {
    path: PropTypes.string.isRequired
  }

  const goTo = path => {
    setPrevPage(location.pathname)
    navigate(path === HOME_PATH ? path : path)
  }
  goTo.propTypes = {
    path: PropTypes.string.isRequired
  }

  const push = path => {
    navigate(path === HOME_PATH ? path : path)
  }
  push.propTypes = {
    path: PropTypes.string.isRequired
  }

  const goPrevPage = () => {
    const last = sessionStorage.getItem(LAST_VISIT)
    const prev = sessionStorage.getItem(PREV_PAGE)
    const path =
      last && prev && prev !== SIGN_IN_PATH
        ? last.toString() === prev.toString()
          ? HOME_PATH
          : prev.toString()
        : HOME_PATH
    goTo(path)
  }

  const unAuthByStatus = status => {
    if (status && (Number(status) === 401 || Number(status) === 403)) {
      authStoreFunc?.logout && authStoreFunc.logout()
      return goTo(SIGN_IN_PATH)
    }
    return true
  }

  const isReloadedPage = () => {
    const prev = sessionStorage.getItem(PREV_PAGE)
    return location.pathname === prev.toString()
  }

  return {
    goTo,
    setLastVisit,
    setPrevPage,
    goPrevPage,
    push,
    unAuthByStatus,
    isReloadedPage,
    prevPage,
    lastVisit
  }
}
export default useRoutes
